export const tutorial: Record<string, string> = {
  Articles: 'Cikkek',
  Bold: 'Félkövér',
  'Bulleted list': 'Felsorolás',
  Formatting: 'Formázás',
  'Heading 1': 'Címsor 1',
  'Heading 2': 'Címsor 2',
  'Image URL': 'Kép címe',
  'Insert image': 'Kép beszúrása',
  'Insert link': 'Hivatkozás beszúrása',
  'Insert table': 'Táblázat beszúrása',
  Italic: 'Dőlt',
  'Link URL': 'Hivatkozás címe',
  'Numbered list': 'Számozott lista',
  'Only Innozenit administrators can edit tutorial content.':
    'Az útmutatót csak Innozenit-rendszergazda szerkesztheti.',
  'Publish tutorial': 'Útmutató közzététele',
  Redo: 'Újra',
  'Save tutorial': 'Útmutató mentése',
  Title: 'Cím',
  Underline: 'Aláhúzott',
  Undo: 'Visszavonás',
  Published: 'Közzétéve',
  'Tutorial saved.': 'Oktatóanyag mentve.',
  'Tutorial published.': 'Oktatóanyag közzétéve.',
};
